import { render, staticRenderFns } from "./allocationIndex.vue?vue&type=template&id=545206d3&scoped=true&"
import script from "./allocationIndex.vue?vue&type=script&lang=js&"
export * from "./allocationIndex.vue?vue&type=script&lang=js&"
import style0 from "./allocationIndex.vue?vue&type=style&index=0&id=545206d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545206d3",
  null
  
)

export default component.exports